import React, { useState, useEffect } from "react";
import img from "./Img/betterwithoutlogo.webp";

function Demo() {
  const [isLargeScreen, setIsLargeScreen] = useState(
    () => window.matchMedia("(min-width: 1280px)").matches,
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 1280px)");
    const handleChange = (e) => setIsLargeScreen(e.matches);
    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);
  return (
    <>
      {isLargeScreen && (
        <div className="parent-container m-0 uh-150 d-flex align-items-center">
          <div className="upx-25 uh-110 uw-200 text-start">
            <>
              <p className=" fw-bold uufs-142 m-0 p-0 lh-sm">Keep your</p>
              <p className="fw-bold ufs-14 m-0 p-0 lh-sm">
                <span style={{ color: "#46b1e1" }}>SUPERPOWER!!!</span>
              </p>
              <p className=" fw-bold ufs-12 m-0 p-0 lh-sm">
                always within reach
              </p>
              <p className="fw-bold ufs-7 m-0 upy-15">
                You are<span style={{ color: "#46b1e1" }}> JUST ONE</span> click
                away from your dream
              </p>
            </>
            {/* <div className="uw-90 uh-16">
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLScJX9zGSm7uGiT1FYF1m33zA4oQi2NbBRHniRLHAUtdjifmOA/viewform?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button
                  className=" ufs-6 m-0 p-0 uw-90 uh-14 text-center text-white border-0 fw-bold bg-blue br-10"
                  type="button"
                >
                  Book my Demo
                </button>
              </a>
            </div> */}
          </div>
          <div className="upt-5 uw-80">
            <div
              className="uh-120 m-0 p-0 uw-67"
              style={{
                backgroundImage: `url(${img})`,
                backgroundSize: "contain",
                backgroundPosition: "center",
              }}
            ></div>
          </div>
        </div>
      )}
      {!isLargeScreen && (
        <div className="parent-container m-0 uh-300 px-3 d-flex  align-items-center">
          <div className="upx-25 m-0 vh-75 w-75 text-start justify-content-center">
            <>
              <h2 className=" fw-bold ufs-14  m-0 p-0 lh-sm">Keep your</h2>
              <p className="fw-bold ufs-14   m-0 p-0 lh-sm">
                <span style={{ color: "#46b1e1" }}>SUPERPOWER!!!</span>
              </p>
              <p className=" fw-bold ufs-12 m-0 p-0 lh-sm">
                always within reach
              </p>
              <p className="fw-bold ufs-13 m-0 upy-15">
                You are<span style={{ color: "#46b1e1" }}> JUST ONE</span> click
                away from your dream
              </p>
            </>
            {/* <div className="w-75 uh-16">
      <a
        href="https://docs.google.com/forms/d/e/1FAIpQLScJX9zGSm7uGiT1FYF1m33zA4oQi2NbBRHniRLHAUtdjifmOA/viewform?usp=sharing"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button
          className=" ufs-12 m-0 upy-5 upx-10 text-center text-white border-0 fw-bold bg-blue br-20"
          type="button"
        >
          Book my Demo
        </button>
      </a>
      </div> */}
          </div>
          <div className="upt-5 w-25">
            <div
              className="uh-140 m-0 p-0 "
              style={{
                backgroundImage: `url(${img})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            ></div>
          </div>
        </div>
      )}
    </>
  );
}

export default Demo;
